<!-- #region HTML -->
<template>
    <div class="app">
        <meta name="referrer" content="origin-when-cross-origin" />
        <!-- #region Alert Component -->
        <alert :SystemErrorAlert="isSystemError" @update:SystemErrorAlert="isSystemError = $event"
            :DeleteAccountFailureAlert="isDeleteAccountFailure"
            @update:DeleteAccountFailureAlert="isDeleteAccountFailure = $event" />
        <!-- #endregion -->
        <!-- #region Main Container -->
        <div class="main-container form-container">
            <!-- #region Steps Section -->
            <div class="right-box">
                <div class="steps">
                    <div class="right-box">
                        <div class="sub-container">
                            <div class="title"><label>アカウント削除</label></div>
                        </div>
                    </div>
                </div>
            </div>
            <md-card class="form-container">
                <div v-if="loading == false && deleting == false">
                    <template>
                        <component :is="selectedLayout" @buttonClick="callValidator">
                            <template v-slot:expireDate>
                                {{ currentPeriodEnd }}
                            </template>
                            <template v-slot:appStore>
                                {{ appStore }}
                            </template>
                            <template v-slot:course>
                                {{ courseDuration }}
                            </template>
                            <template v-slot:button>

                                <button @click="showConfirmationDialog()" :disabled="confirming"
                                    class="mt-10 mb-10 md-button button-2 primary-button">削除する</button>
                            </template>
                        </component>
                    </template>
                </div>
                <div v-else-if="deleting == true">
                    <template>
                        <div class="delete-page-loader-1 delete-container skeleton-deleter">
                        </div>
                        <div class="delete-page-loader-2 delete-container skeleton-deleter">
                        </div>
                    </template>
                </div>
                <div v-else>
                    <template>
                        <div class="delete-page-loader-1 delete-container skeleton-loader">
                            <!-- <p>Loading</p> -->
                        </div>
                        <div class="delete-page-loader-2 delete-container skeleton-loader">
                            <!-- <p>Loading</p> -->
                        </div>
                    </template>
                </div>
            </md-card>
            <template>
                <DeletionConfirmationLayout ref="confirmTarget">
                    <template v-slot:checkbox>
                        <input type="checkbox" id="deleteCheckbox" v-model="isChecked">
                        <label for="deleteCheckbox">上記内容を確認した上で、アカウントを削除することを希望します。</label>
                    </template>
                    <template v-slot:deleteButton>
                        <div class="button-container pt-10 pb-10 flex-siblings-responsive">
                            <button @click="closeConfirmationDialog()"
                                class="mt-10 mb-10 md-button primary-button secondary-button">キャンセル</button>
                            <div class="spacer-30px"></div>
                            <button @click="callValidatorAndDelete()" :disabled="!isChecked"
                                class="mt-10 mb-10 md-button primary-button">削除する</button>
                        </div>
                    </template>
                </DeletionConfirmationLayout>
            </template>
            <!-- #endregion -->
        </div>
        <!-- #endregion -->
    </div>
</template>
<!-- #endregion -->
<!-- #region JavaScript -->
<script>
// @ is an alias to /src
import awsconfig from '@/aws-exports'
import apiUrl from '@/const/deleter-api-lambda-url.js'
import Alert from '@/layout/Alerts.vue';

import DeleteFLayout from '@/layout/deleteAccountLayouts/DeleteFLayout.vue';
import DeletePSTRIPECANCELEDLayout from '@/layout/deleteAccountLayouts/DeleteStripeCanceledLayout.vue';
import DeletePSTRIPELayout from '@/layout/deleteAccountLayouts/DeleteStripeLayout.vue';
import DeletePAPPLayout from '@/layout/deleteAccountLayouts/DeleteAppLayout.vue';
import DeletePBULKLayout from '@/layout/deleteAccountLayouts/DeleteBulkLayout.vue';

import UserNotFoundLayout from '@/layout/deleteAccountLayouts/UserNotFoundLayout.vue';

import { Auth } from 'aws-amplify';
import { revokeShopAuthCookies } from '@/services/CookieService';
import { validationMixin } from 'vuelidate';

import DeletionConfirmationLayout from '@/layout/deleteAccountLayouts/DeletionConfirmationLayout.vue';

let cognito_user
export default {
    name: 'DeleteAccount',
    mixins: [validationMixin],
    components: {
        "alert": Alert,
        "DeleteFLayout": DeleteFLayout,
        "DeletePSTRIPELayout": DeletePSTRIPELayout,
        "DeletePSTRIPECANCELEDLayout": DeletePSTRIPECANCELEDLayout,
        "DeletePAPPLayout": DeletePAPPLayout,
        "DeletePBULKLayout": DeletePBULKLayout,
        "UserNotFoundLayout": UserNotFoundLayout,
        DeletionConfirmationLayout,
    },
    props: {
    },
    data() {
        return {
            user: {
                userType: 'P-Stripe',
                appStore: 'Apple',
                isMonthly: false,
                currentPeriodEnd: '1111/01/01',
                status: 'X',
                deletionAttempted: 'DeleteTry',
                deletionOutcome: 'DeleteOut',
                deletionDetails: 'DeleteDetails',
                selectedLayout: null,
                courseDuration: "年額コース",
            },
            sending: false,
            isSystemError: false,
            isDeleteAccountFailure: false,
            loading: true,
            confirming: false,
            deleting: false,
            isChecked: false,
            deleteButtonDisabled: true
        };
    },
    watch: {
        isChecked(newValue) {
            this.deleteButtonDisabled = !newValue;
        }
    },
    async mounted() {
        await this.callValidator();
        this.loading = false;
    },
    methods: {
        showConfirmationDialog() {
            this.confirming = true
            this.$refs.confirmTarget.showConfirmation();
        },
        closeConfirmationDialog() {
            this.confirming = false
            this.$refs.confirmTarget.closeConfirmation();
        },
        clearErrorFlag() {
            this.isSystemError = false
            this.isDeleteAccountFailure = false
        },
        userNotFoundError() {
            this.selectedLayout = UserNotFoundLayout
            this.isSystemError = true
            this.scrollToTop()
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        async callValidator() {
            try {
                const user = await Auth.currentAuthenticatedUser();
                cognito_user = user
            } catch (error) {
                this.userNotFoundError()
            }
            this.clearErrorFlag()
            const idToken = cognito_user.signInUserSession.idToken.jwtToken;
            try {
                const API_URL = apiUrl.get_validator_api_url(awsconfig.aws_user_pools_id)
                const response = await fetch(API_URL, {
                    method: 'POST',
                    mode: "cors",
                    headers: {
                        'x-id-token': idToken,
                        'Content-Type': 'application/json',
                        'Origin': window.location.origin,
                    },
                });
                const data = await response.json();
                if (data.statusCode === 200) {
                    // console.log("Full data is: " + JSON.stringify(data));
                    this.userType = data.userType
                    const cleanedAppStore = data.appStore.replace(/[^a-zA-Z]/g, "");
                    this.appStore = cleanedAppStore
                    this.isMonthly = data.isMonthly
                    this.currentPeriodEnd = data.currentPeriodEnd
                    const cleanedCurrentPeriodEnd = this.currentPeriodEnd.replace(/[\[,''""\]]/g, "");
                    this.currentPeriodEnd = cleanedCurrentPeriodEnd
                } else if (data.statusCode === 404) {
                    console.warn('Validator returned 404 – user not found')
                    this.userNotFoundError()
                }
                else {
                    this.userNotFoundError()
                }
            }
            catch (error) {
                this.userNotFoundError()
            }
            finally {
                this.sending = false;
                const cleanedUserType = this.userType.replace(/[^a-zA-Z]/g, "");
                this.userType = cleanedUserType.toUpperCase()
                this.selectedLayout = this.userType ? 'Delete' + this.userType + 'Layout' : 'DeleteFLayout';
                if (this.isMonthly == false) {
                    this.courseDuration = "月額コース"
                }
                else {
                    this.courseDuration = "年額コース"
                }
                if (this.appStore == "Apple") {
                    this.appStore = "App Store"
                }
                else if (this.appStore == "Google") {
                    this.appStore = "Google Play ストア"
                }
                else {
                    this.appStore = "Mobile"
                }
            }
        },
        cleanApiString(str) {
            return str ? str.replace(/[^a-zA-Z]/g, "") : "";
        },
        cleanApiStringWithQuotes(str) {
            return str ? str.replace(/[\[,''""]\]/g, "") : "";
        },
        async performDeletionValidation(idToken) {
            try {
                const API_URL = apiUrl.get_deletion_validator_api_url(awsconfig.aws_user_pools_id)
                const response = await fetch(API_URL, {
                    method: 'POST',
                    headers: {
                        'x-id-token': idToken,
                        'Content-Type': 'application/json'
                    },
                });
                
                const data = await response.json();
                if (data.statusCode === 200) {
                    const cleanedDeletionOutcome = this.cleanApiString(data.deletionOutcome);
                    return {
                        success: cleanedDeletionOutcome === 'success',
                        data: {
                            userType: data.userType,  
                            appStore: this.cleanApiString(data.appStore),
                            isMonthly: data.isMonthly,
                            currentPeriodEnd: this.cleanApiStringWithQuotes(data.currentPeriodEnd),
                            deletionOutcome: cleanedDeletionOutcome
                        },
                        error: null
                    }
                }
                
                if (data.statusCode === 404) {
                    console.warn('Deletion validator returned 404 – user not found')
                    return { success: false, data: null, error: 'User not found' }
                }
                
                return { success: false, data: null, error: 'Unknown API error' }
            } catch (error) {
                return { success: false, data: null, error: error.message }
            }
        },
        updateComponentState(data) {
            this.userType = this.cleanApiString(data.userType).toUpperCase()
            this.appStore = data.appStore
            this.isMonthly = data.isMonthly
            this.currentPeriodEnd = data.currentPeriodEnd
            this.deletionOutcome = data.deletionOutcome
            this.selectedLayout = this.userType ? 'Delete' + this.userType + 'Layout' : 'DeleteFLayout';
            this.sending = false;
        },
        handleDeletionFailure(error) {
            this.deleting = false
            this.closeConfirmationDialog()
            this.isDeleteAccountFailure = true
            this.scrollToTop()
            this.sending = false;
        },
        async handleSuccessfulDeletion() {
            // Immediately sign the user out to ensure cross-domain cookies are cleared even if the
            // user closes the tab before reaching the completion page.
            try {
                await Auth.signOut({ global: true })
            } catch (e) {
                // Cognito may already consider the user signed-out after deletion – fall back to
                // explicit cookie revocation so other sub-domains are kept in sync.
                try {
                    await revokeShopAuthCookies()
                } catch (_) {/* noop */}
            }
            this.$router.push({ name: 'completeDeleteAccount' })
        },
        async callValidatorAndDelete() {
            try {
                this.deleting = true
                this.closeConfirmationDialog()
                const user = await Auth.currentAuthenticatedUser();
                cognito_user = user
            } catch (error) {
                this.userNotFoundError()
                this.deleting = false
                return
            }
            
            const idToken = cognito_user.signInUserSession.idToken.jwtToken;
            const apiResult = await this.performDeletionValidation(idToken);
            
            if (apiResult.success) {
                // Update component state with successful data
                this.updateComponentState(apiResult.data);
                // Handle successful deletion separately to prevent signout errors from triggering failure alert
                await this.handleSuccessfulDeletion();
            } else {
                // Handle failure
                this.handleDeletionFailure(apiResult.error);
            }
        },
    },
}
</script>
<!-- #endregion -->
<!-- #region CSS -->
<style lang="scss" scoped>
/* #region base CSS */

#deleteCheckbox {
    cursor:pointer;
}

.skeleton-loader {
    background-color: #DDDBDD;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(90deg,
                rgba(#fff, 0) 0,
                rgba(#fff, 0.2) 40%,
                rgba(#fff, 0.5) 50%,
                rgba(#fff, 0));
        animation: shimmer 3s infinite;
        content: '';
    }

}

.skeleton-deleter {
    display: inline-block;
    position: relative;
    overflow: hidden;
    vertical-align: middle;
    background-color: #DDDBDD;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(90deg,
                rgba(#8b1b1f, 0) 0,
                rgba(#8b1b1f, 0.2) 40%,
                rgba(#8b1b1f, 0.5) 50%,
                rgba(#8b1b1f, 0));
        animation: shimmer 3s infinite;
        content: '';
    }
}

@keyframes shimmer {
    100% {
        transform: translateX(100%);
    }
}

/* #endregion */
</style>
<!-- #endregion -->